/**
 * @file: AiCreditQuotaPeriod.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum AiCreditQuotaPeriod {
  Day = 'day',
  Month = 'month',
}

export const AiCreditQuotaPeriodValueSet = new Set([
  AiCreditQuotaPeriod.Day,
  AiCreditQuotaPeriod.Month,
]);
